import { render, staticRenderFns } from "./CreateLimitPage.vue?vue&type=template&id=0edb6a31"
import script from "./CreateLimitPage.vue?vue&type=script&lang=js"
export * from "./CreateLimitPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports